import React from 'react'
import { Discover, InteractiveCanvas, Storyboard } from '../containers'
import { Connect } from '../components/common'

const Homepage = () => {  
    return (
        <div className="home">
            <Discover />
            {/* <InteractiveCanvas /> */}
            <Storyboard />
            <Connect />
        </div>
    )
}

export default Homepage